import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} width={15} height={11} fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M4.988 8.913L13.35.55A.812.812 0 1114.5 1.7l-8.938 8.937a.813.813 0 01-1.149 0L.351 6.575A.812.812 0 111.5 5.425l3.488 3.488z" fill="#9738FF" /></svg>;
}
export default SvgComponent;